import React, { useState, useEffect, useRef } from "react";
import CustomError from "../../../../utils/customError";

const GoogleAddressInput = ({ formik, name = "address", t, placeholderKey, errorCodes = [] }) => {
  const [suggestions, setSuggestions] = useState([]);
  const [service, setService] = useState(null);
  const containerRef = useRef(null);

  useEffect(() => {
    if (window.google && window.google.maps) {
      const autocompleteService = new window.google.maps.places.AutocompleteService();
      setService(autocompleteService);
    }
  }, []);

  // ✅ Close dropdown when clicking outside
  useEffect(() => {
    const handleClickOutside = (event) => {
      if (containerRef.current && !containerRef.current.contains(event.target)) {
        setSuggestions([]);
      }
    };
    document.addEventListener("mousedown", handleClickOutside);
    return () => document.removeEventListener("mousedown", handleClickOutside);
  }, []);

  const handleChange = (e) => {
    const value = e.target.value;
    formik.setFieldValue(name, value);

    if (!value || !service) {
      setSuggestions([]);
      return;
    }

    service.getPlacePredictions(
      { input: value, types: ["geocode"], componentRestrictions: { country: "in" } },
      (predictions, status) => {
        if (
          status === window.google.maps.places.PlacesServiceStatus.OK &&
          predictions
        ) {
          setSuggestions(predictions);
        } else {
          setSuggestions([]);
        }
      }
    );
  };

  const handleSelect = (suggestion) => {
    formik.setFieldValue(name, suggestion.description);
    setSuggestions([]);
  };

  return (
    <div className="col-md-6 text-center form-group position-relative" ref={containerRef}>
      <label htmlFor={name} className="text-left d-flex">
        {t("admin.cafes.label_address")}:<span className="requirestar">*</span>
      </label>

      <input
        name={name}
        id={name}
        type="text"
        onChange={handleChange}
        onBlur={formik.handleBlur}
        value={formik.values[name]}
        className="form-control"
        placeholder={t(placeholderKey || "admin.cafes.placeholder_address")}
        autoComplete="off"
      />

      {suggestions.length > 0 && (
        <ul
          className="list-group position-absolute w-100 shadow-sm"
          style={{
            zIndex: 1000,
            maxHeight: "200px",
            overflowY: "auto",
            top: "100%",
          }}
        >
          {suggestions.map((s) => (
            <li
              key={s.place_id}
              className="list-group-item list-group-item-action text-start"
              onMouseDown={() => handleSelect(s)}
              style={{ cursor: "pointer" }}
            >
              {s.description}
            </li>
          ))}
        </ul>
      )}

      <span className="text-danger d-flex text-left">
        <CustomError shortCodes={errorCodes} name={name} form={formik} />
      </span>
    </div>
  );
};

export default GoogleAddressInput;
